
export const refreshTokenAPI = async (refreshToken) => {

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const version = "v1";
    
  const response = await fetch(`${baseUrl}/${version}/user/refresh-token`, {
    method: "POST",
    body: JSON.stringify({ refreshToken }),
    headers: { "Content-Type": "application/json" }
  });

  if (!response.ok) throw new Error("Refresh token failed");

  return response.json();
};
